import React from 'react';

const GraystoneFederalLogo = (props: any) => (
  <svg
    viewBox="0 0 175 48"
    xmlns="http://www.w3.org/2000/svg"
    className="rethink-sans"
    {...props}
    transform="scale(1,1)"

  >
    {/* Black rounded square */}
    <g transform="matrix(1 0 0 1 0 0)" >
      <rect
        x="0"
        y="0"
        width="43.7"
        height="48.2"
        rx="6.22"
        ry="6.22"
        fill={props.boxColor || "#020202"}
      />
    </g>
    <text
      x="23.5"
      y="28"
      fontFamily="Rethink Sans, sans-serif"
      fontSize="44"
      fontWeight="700"
      fill={props.textColor || "#fff"}
      dominantBaseline="middle"
      textAnchor="middle"
      transform="scale(0.925,1)"
    >
      G
    </text>
    <defs>
    <linearGradient id="grad1" x1="0%" x2="100%" y1="0%" y2="0%">
      <stop offset="0%" stop-color="rgb(28, 28, 28)" />
      <stop offset="100%" stop-color="rgb(139, 27, 27)" />
    </linearGradient>
  </defs>
    <rect
        x="8"
        y="43"
        width="27.5"
        height="1.2"
        rx="1.22"
        ry="1.22"
        fill="url(#grad1)"
        // fill='#a60000'
        // fill="linear-gradient(rgb(42, 42, 42), rgb(139, 27, 27))"
      />
    {/* Company name */}
    <text
      x="38"
      y="20"
      fontFamily="Rethink Sans, sans-serif"
      fontSize="12"
      fontWeight="700"
      fill={props.nameColor || "#fff"}
    >
      <tspan x="48" y="28">GRAYSTONE FEDERAL</tspan>
    </text>
  </svg>
);

export default GraystoneFederalLogo; 